module.exports = __webpack_public_path__ + "assets/img/24_1069.88f2fe0c.jpg";